export const primaryLight = {
  25: '#F7FBFF',
  50: '#F4F9FF',
  100: '#E9F2FF',
  200: '#DAEAFF',
  300: '#C4DBFA',
  400: '#A6C9F5',
  500: '#79A6E0',
  600: '#5B8AC5',
  700: '#3F6798',
  800: '#2A4B73',
  900: '#16283E',
};

export const primaryDark = {
  25: '#16283E',
  50: '#2A4B73',
  100: '#3F6798',
  200: '#5B8AC5',
  300: '#79A6E0',
  400: '#A6C9F5',
  500: '#C4DBFA',
  600: '#DAEAFF',
  700: '#E9F2FF',
  800: '#F4F9FF',
  900: '#F7FBFF',
};

export const greyLight = {
  25: '#FCFCFD',
  50: '#F9FAFB',
  100: '#F2F4F7',
  200: '#EAECF0',
  300: '#D0D5DD',
  400: '#98A2B3',
  500: '#667085',
  600: '#475467',
  700: '#344054',
  800: '#1D2939',
  900: '#101828',
};

export const greyDark = {
  25: '#101828',
  50: '#1D2939',
  100: '#242C3A',
  200: '#344054',
  300: '#475467',
  400: '#667085',
  500: '#98A2B3',
  600: '#D0D5DD',
  700: '#EAECF0',
  800: '#F2F4F7',
  900: '#F9FAFB',
};

export const errorLight = {
  25: '#FFFBFA',
  50: '#FEF3F2',
  100: '#FEE4E2',
  200: '#FECDCA',
  300: '#FDA29B',
  400: '#F97066',
  500: '#F04438',
  600: '#D92D20',
  700: '#B42318',
  800: '#912018',
  900: '#7A271A',
};

export const errorDark = {
  25: '#EC564B29',
  50: '#EC564B3D',
  100: '#EC564B52',
  200: '#EC564B7A',
  300: '#EC564BA3',
  400: '#EC564B',
  500: '#EE6C62',
  600: '#F1827A',
  700: '#F49B95',
  800: '#F6B1AC',
  900: '#FBDCDA',
};

export const warningLight = {
  25: '#FFFCF5',
  50: '#FFFAEB',
  100: '#FEF0C7',
  200: '#FEDF89',
  300: '#FEC84B',
  400: '#FDB022',
  500: '#F79009',
  600: '#DC6803',
  700: '#B54708',
  800: '#93370D',
  900: '#7A2E0E',
};

export const warningDark = {
  25: '#FDB02229',
  50: '#FDB0223D',
  100: '#FDB02252',
  200: '#FDB0227A',
  300: '#FDB022A3',
  400: '#FDB022',
  500: '#FEC84B',
  600: '#FEDF89',
  700: '#FEF0C7',
  800: '#FFFAEB',
  900: '#FFFCF5',
};

export const successLight = {
  25: '#F6FEF9',
  50: '#ECFDF3',
  100: '#D1FADF',
  200: '#A6F4C5',
  300: '#6CE9A6',
  400: '#32D583',
  500: '#12B76A',
  600: '#039855',
  700: '#027A48',
  800: '#05603A',
  900: '#054F31',
};

export const successDark = {
  25: '#32D58329',
  50: '#32D5833D',
  100: '#32D58352',
  200: '#32D5837A',
  300: '#32D583A3',
  400: '#32D583',
  500: '#6CE9A6',
  600: '#A6F4C5',
  700: '#D1FADF',
  800: '#ECFDF3',
  900: '#F6FEF9',
};

export const baseLight = {
  primary: '#5B8AC5',
  errorPrimary: '#F97066',
  buttonText: '#FCFCFD',
  foreground: '#000000',
  background: '#FFFFFF',
  // New
  bodyText: '#101828',
};

export const baseDark = {
  primary: '#5B8AC5',
  errorPrimary: '#F97066',
  buttonText: '#FCFCFD',
  foreground: '#FFFFFF',
  background: '#171E30',
  // New
  bodyText: '#F9FAFB',
};

export const chartsColors = [
  '#5B8AC5',
  '#5B66C5',
  '#825BC5',
  '#3B3384',
  '#4D838D',
  '#3BA891',
  '#3B99A8',
  '#3B66A8',
  '#97568B',
  '#38664A',
  '#81884B',
  '#2E7483',
  '#6341C3',
  '#713F89',
  '#665938',
  '#A83B5F',
  '#A83D3B',
  '#A8703B',
  '#9AA83B',
  '#663859',
];
